import React, { ChangeEvent, useContext, useEffect, useState } from "react";

import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

import { Snackbar, TableCell } from "@mui/material";
import { TableBody, TableFooter, TableHead } from "@mui/material";
import { TableContainer, TableRow } from "@mui/material";
import { TextField } from "@mui/material";
import { Box, Paper, Stack } from "@mui/material";
import { TablePagination } from "@mui/material";

import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import { del, get, post } from "../../../Services/tokenConfig";
import TablePaginationActions from "../../../Components/Pagination/pagination";

import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { StyledTableHead, StyledTableCell, } from "../../../Styles/tabelCellStyled/customTableCell";
import { ICabecalho8, IPage8 } from "../../../Interfaces/cadernos/caderno8";
import { CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { func_print } from "../../../Func_genericas/func_print";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { Alert } from "../../../Components/Alert/Alert";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { CabecalhoForm } from "./cabecalho";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";
import { FilterByData } from "../../../Func_genericas/filter_by_data";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(0),
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  })
);


export default function RegPosColheita() {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const classes = useStyles();
  const [message, setMessage] = React.useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [obj_anexo_cabecalho_selecionado, set_obj_anexo_cabecalho_selecionado] = useState<ICabecalho8 | undefined>();

  const [openDelete, setOpenDelete] = React.useState<boolean>(false);
  const [showNewRow, setShowNewRow] = useState<boolean>(false);
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = React.useState<boolean>(false);
  const [page, setPage] = React.useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(5);
  const [rows, setRows] = useState<IPage8[]>([]);
  const [rows_filtrada, setRows_filtrada] = useState<IPage8[]>([]);
  const [obj_colheita, set_obj_Colheita] = useState<IPage8 | undefined>();

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handleCancel()
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  /***************** TABELA REGISTO POS COLHEITA ******************************************/
  async function getTabela() {
    setIsLoading(true);
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_pos_colheita_oito_cabecalho/${obj_anexo_cabecalho_selecionado?.id_registo_colh}`);
      if (res.status === 200) {
        setRows(res.data.result);
        setRows_filtrada(res.data.result);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getOperacoesCulturais", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      if (obj_anexo_cabecalho_selecionado !== undefined) {

        await getTabela();

        set_obj_Colheita((tab: any) => ({
          ...tab,
          id_registo_colh: obj_anexo_cabecalho_selecionado.id_registo_colh
        }))
      } else {
        setIsLoading(false)
      }

    })();
  }, [obj_anexo_cabecalho_selecionado]);

  // CRIAR
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    set_flag_editado(true)

    set_obj_Colheita((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {

    try {
      setIsLoading(true);

      let res = await post(auth.token.cookie_token, "new_reg_pos_colheita_oito", {
        payload: {
          id_registo_pos_colhe: 0,
          data: obj_colheita?.data === undefined ? null : obj_colheita.data,
          embalagem: obj_colheita?.embalagem === undefined ? "" : obj_colheita.embalagem,
          quantificacao: obj_colheita?.quantificacao === undefined ? null : obj_colheita.quantificacao,
          destinatario: obj_colheita?.destinatario === undefined ? "" : obj_colheita.destinatario,
          quantificacao_dois: obj_colheita?.quantificacao_dois === undefined ? null : obj_colheita.quantificacao_dois,
          id_registo_colh: obj_anexo_cabecalho_selecionado?.id_registo_colh,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      });
      if (res.status === 200) {
        setMessage("Gravado com sucesso!");
        setOpenSnackSuccess(true);
        setShowNewRow(false);
        set_flag_editado(false)
        set_obj_Colheita(undefined);
        setRows((prevRows) => {
          return [...prevRows,
          (res.data.result),
          ];
        })
        setRows_filtrada((prevRows) => {
          return [...prevRows,
          (res.data.result),
          ];
        })
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);

    } catch (error) {
      func_print("handleSave", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }

  };
  const handleCancel = () => {
    setShowNewRow(false);
    set_obj_Colheita(undefined);
  }

  // EDIT
  const handleEdit = (obj: IPage8) => {
    set_obj_Colheita(obj);
  };


  const handleUpdateTabela = async () => {

    try {
      setIsLoading(true);

      const res = await post(auth.token.cookie_token, "/update_reg_pos_colheita_oito", {
        payload: {
          id_registo_pos_colhe: obj_colheita?.id_registo_pos_colhe,
          data: obj_colheita?.data === undefined ? null : obj_colheita.data,
          embalagem: obj_colheita?.embalagem === undefined ? "" : obj_colheita.embalagem,
          quantificacao: obj_colheita?.quantificacao === undefined ? null : obj_colheita.quantificacao,
          destinatario: obj_colheita?.destinatario === undefined ? "" : obj_colheita.destinatario,
          quantificacao_dois: obj_colheita?.quantificacao_dois === undefined ? null : obj_colheita.quantificacao_dois,
          id_registo_colh: obj_colheita?.id_registo_colh,
          last_update: obj_colheita?.last_update,
          create_date: obj_colheita?.create_date,
          uuid: obj_colheita?.uuid,
        }
      });
      if (res.status === 200) {
        setMessage("Registado com sucesso!");

        const updatedRows = rows.map((row) => {
          if (row.id_registo_pos_colhe === res.data.result.id_registo_pos_colhe) {
            return (res.data.result);
          } else {
            return row
          }
        });

        setRows(updatedRows !== undefined ? updatedRows : []);
        setRows_filtrada(updatedRows !== undefined ? updatedRows : []);
        set_obj_Colheita(undefined);
        setOpenSnackSuccess(true);
        set_flag_editado(false)

      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);

    } catch (error) {
      func_print("handleUpdate", error, true);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);
      setIsLoading(false);
    }

  };

  // Delete
  const handleClickOpenDelete = (obj: IPage8) => {
    set_obj_Colheita(obj);

    setOpenDelete(true);
  };
  const handleDelete = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_pos_colheita_oito/${obj_colheita?.id_registo_pos_colhe}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDelete(false);
        setRows((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_pos_colhe !== obj_colheita?.id_registo_pos_colhe),
        ]);
        setRows_filtrada((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_pos_colhe !== obj_colheita?.id_registo_pos_colhe),
        ]);
        set_obj_Colheita(undefined);

        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  /*****************  PAGINAÇÃO ********************** */
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows_filtrada.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={classes.root}>
      <CadernoLayout title="8 - Registo Pós-colheita" />
      <main className={classes.contents}>
        <div className={classes.toolbars} />
        <Box width="80%" margin="auto">
          <BeneficiarioNomeIdAlinhadoDireita />
        </Box>
        <FilterByData
          listas={[
            {
              lista_original: rows,
              set_lista_filtrada: setRows_filtrada,
              campoData: "data",
            },

          ]}
        />
        <CabecalhoForm
          obj_anexo_cabecalho_selecionado={obj_anexo_cabecalho_selecionado}
          set_obj_anexo_cabecalho_selecionado={set_obj_anexo_cabecalho_selecionado}
        />

        {isLoading ? (
          <LoadingVulpes />
        ) : (
          obj_anexo_cabecalho_selecionado !== undefined ?

            <>
              <CustomThemeProvider>
                <TableContainer
                  component={Paper}
                  sx={{
                    height: "auto",
                    width: "auto",
                    margin: 2,
                    padding: 2,
                  }}
                >
                  <Snackbar
                    open={openSnackSuccess}
                    autoHideDuration={2000}
                    onClose={() => setOpenSnackSuccess(false)}
                  >
                    <Alert
                      onClose={() => setOpenSnackSuccess(false)}
                      severity="success"
                      sx={{ width: "100%" }}
                    >
                      {message}
                    </Alert>
                  </Snackbar>
                  <Snackbar
                    open={openSnackError}
                    autoHideDuration={2000}
                    onClose={() => setOpenSnackError(false)}
                  >
                    <Alert
                      onClose={() => setOpenSnackError(false)}
                      severity="error"
                      sx={{ width: "100%" }}
                    >
                      {message}
                    </Alert>
                  </Snackbar>
                  <Box sx={{ display: "flex", justifyContent: "end" }}>
                    {is_historico === true ? <></> :

                      <BarraDeFerramentas
                        mostrarBotaoNovo
                        textoBotaoNovo="Novo Registo"
                        aoClicarNovo={() => { setShowNewRow(true) }}
                      />}
                  </Box>
                  <table style={{ width: "100%" }}>
                    <TableHead>
                      <TableRow>
                        <StyledTableHead rowSpan={2}>Data</StyledTableHead>
                        <StyledTableHead colSpan={2}>
                          Processamento
                        </StyledTableHead>
                        <StyledTableHead colSpan={2}>
                          Comercialização
                        </StyledTableHead>
                        <StyledTableCell rowSpan={2}>Ações</StyledTableCell>
                      </TableRow>

                      <TableRow>
                        <StyledTableCell>
                          Embalagem, transformação
                        </StyledTableCell>
                        <StyledTableCell>Quantificação (Lote n.)</StyledTableCell>
                        <StyledTableCell>Destinatário</StyledTableCell>
                        <StyledTableCell>Quantificação (Lote nº)</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        {showNewRow && (
                          <>
                            <StyledTableCell>
                              <TextField
                                variant="filled"
                                type="date"
                                name="data"
                                value={obj_colheita?.data === undefined ? "" : obj_colheita.data}
                                onChange={handleInputChange}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="embalagem"
                                value={obj_colheita?.embalagem === undefined ? "" : obj_colheita.embalagem}
                                onChange={handleInputChange}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="quantificacao"
                                value={obj_colheita?.quantificacao === undefined ? "" : obj_colheita?.quantificacao}
                                onChange={handleInputChange}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="destinatario"
                                value={obj_colheita?.destinatario === undefined ? "" : obj_colheita?.destinatario}
                                onChange={handleInputChange}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="quantificacao_dois"
                                value={obj_colheita?.quantificacao_dois === undefined ? "" : obj_colheita?.quantificacao_dois}
                                onChange={handleInputChange}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <Stack direction="row" justifyContent="center">
                                <ButtonCadernos
                                  mostrarBotaoCancelar
                                  aoClicarCancelar={() => {
                                    if (flag_editado) {
                                      set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                    } else {
                                      handleCancel()
                                    }
                                  }}
                                  mostrarBotaoGravar
                                  aoClicarGravar={() => handleSave()}
                                />
                              </Stack>
                            </StyledTableCell>
                          </>
                        )}
                      </TableRow>
                      {(rowsPerPage > 0
                        ? rows_filtrada.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        : rows_filtrada
                      ).map((row, key) => (
                        <TableRow key={key}>
                          {obj_colheita?.id_registo_pos_colhe === row.id_registo_pos_colhe ? (
                            <>
                              <StyledTableCell>
                                <TextField
                                  variant="filled"
                                  type="date"
                                  name="data"
                                  value={obj_colheita?.data}
                                  onChange={handleInputChange}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <CustomTextField
                                  name="embalagem"
                                  value={obj_colheita?.embalagem}
                                  onChange={handleInputChange}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <CustomTextField
                                  name="quantificacao"
                                  value={obj_colheita?.quantificacao}
                                  onChange={handleInputChange}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <CustomTextField
                                  name="destinatario"
                                  value={obj_colheita?.destinatario}
                                  onChange={handleInputChange}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <CustomTextField
                                  name="quantificacao_dois"
                                  value={obj_colheita?.quantificacao_dois}
                                  onChange={handleInputChange}
                                />
                              </StyledTableCell>
                            </>
                          ) : (
                            <>
                              <StyledTableCell>{row.data} </StyledTableCell>
                              <StyledTableCell>{row.embalagem}</StyledTableCell>
                              <StyledTableCell>
                                {row.quantificacao}
                              </StyledTableCell>
                              <StyledTableCell>
                                {row.destinatario}
                              </StyledTableCell>
                              <StyledTableCell>
                                {row.quantificacao_dois}
                              </StyledTableCell>
                            </>
                          )}

                          {obj_colheita?.id_registo_pos_colhe === row.id_registo_pos_colhe ? (
                            <StyledTableCell>
                              <ButtonCadernos
                                mostrarBotaoGravar
                                aoClicarGravar={() => handleUpdateTabela()}
                                mostrarBotaoCancelar
                                aoClicarCancelar={() => {
                                  if (flag_editado) {
                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                  } else {
                                    handleCancel()
                                  }
                                }}
                              />
                            </StyledTableCell>
                          ) : (
                            <StyledTableCell>
                              {is_historico === true ? <></> :

                                <ButtonCadernos
                                  mostrarBotaoEditar
                                  aoClicarEditar={() =>
                                    handleEdit(row)
                                  }
                                  mostrarBotaoApagar
                                  aoClicarApagar={() =>
                                    handleClickOpenDelete(
                                      row
                                    )
                                  }
                                />}
                            </StyledTableCell>
                          )}
                        </TableRow>
                      ))}

                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={12} />
                        </TableRow>
                      )}
                    </TableBody>
                    <TableFooter>
                      <TableRow sx={{ width: "100%" }}>
                        <TablePagination
                          rowsPerPageOptions={[
                            5,
                            10,
                            25,
                            { label: "All", value: -1 },
                          ]}
                          colSpan={14}
                          count={rows_filtrada.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          labelDisplayedRows={({ from, to, count }) => {
                            return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                          }}
                          labelRowsPerPage={'Linhas por página'}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                        />
                      </TableRow>
                    </TableFooter>
                  </table>
                </TableContainer>
                <ConfirmDialog
                  open={openDelete}
                  onClose={() => setOpenDelete(false)}
                  onConfirm={handleDelete}
                  message="Deseja eliminar o registo?"
                />
                <ConfirmDialog
                  open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                  onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                  onConfirm={() => handleCloseDialog()}
                  message={mensagem_tem_a_certeza_de_apagar_alteracoes}
                />
              </CustomThemeProvider>
            </>
            :
            <></>
        )}
      </main>
    </div>
  );
}